<div id="outer" class="well container">
    @if (loading) {
        <div class="loading"></div>
    }
    <div class="col-md-12">
        <div class="well-notify"></div>
    </div>
    <div class="well-title">
        <div class="col-md-12">Manage Keywords</div>
    </div>
    <div class="col-md-12 well-content">
        <div style="display: flex; gap: 8px; align-items: center">
            <div class="control-label">Keyword Name:</div>
            <input
                nz-input
                [(ngModel)]="searchValue"
                placeholder="Enter keyword name..."
                style="width: 200px"
                (keydown.enter)="onSearch()" />
            <button nz-button nzType="primary" (click)="onSearch()">Search</button>
            <button nz-button (click)="clearSearch()">Reset</button>
        </div>
        <div style="margin-top: 10px; margin-bottom: 16px; display: flex; gap: 8px; align-items: center">
            <button nz-button class="btn-success" [routerLink]="['/configure/keywordcreate']">New Keyword</button>
        </div>
        <nz-table
            #keywordTable
            [nzData]="keywords.Data"
            nzShowSizeChanger
            nzTableLayout="fixed"
            nzBordered="true"
            [nzFrontPagination]="false"
            [nzLoading]="loading"
            [nzTotal]="total"
            [nzShowTotal]="totalTemplate"
            [nzPageSize]="pageSize"
            [nzPageSizeOptions]="pageSizeOptions"
            [nzPageIndex]="pageIndex"
            (nzQueryParams)="onQueryParamsChange($event)">
            <thead style="border: 1px solid black">
                <tr>
                    @for (column of columns; track column) {
                        @if (column.enabled) {
                            <th
                                [nzShowSort]="column.compare"
                                [nzSortFn]="column.compare"
                                [nzColumnKey]="column.fieldName"
                                [nzSortOrder]="getSortOrder(column.fieldName)">
                                {{ column.title }}
                            </th>
                        }
                    }
                </tr>
            </thead>
            <tbody>
                @for (data of keywords.Data; track data.Id) {
                    <tr>
                        <td class="scrollable-cell">{{ data.Name }}</td>
                        <td style="text-align: center">{{ getKeywordTypeName(data.KeywordType) }}</td>
                        <td style="text-align: center">{{ data.Regex }}</td>
                        <td style="text-align: center">{{ data.DateFormat }}</td>
                        <td style="text-align: center">
                            @if (!data.InUse) {
                                <span style="color: green" class="fa-solid fa-check"></span>
                            }
                        </td>
                        <td style="text-align: center">
                            <button
                                nz-button
                                [routerLink]="['/configure/keywordedit']"
                                [queryParams]="{id: data.Id}"
                                nz-tooltip="Edit {{ data.Name }}"
                                class="btn btn-default">
                                <span class="fa-solid fa-pen-to-square"></span>
                            </button>
                        </td>
                    </tr>
                }
            </tbody>
        </nz-table>
        <ng-template #totalTemplate let-total>
            Showing items {{ pageIndex * pageSize - pageSize + 1 }}–{{
                pageIndex * pageSize > total ? total : pageIndex * pageSize
            }}
            out of {{ total }}
        </ng-template>
    </div>
</div>
